import React from 'react';

const AboutPage = () => {
  return (
    <div>
      <div className="pt-4 pb-16 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
          About Us
        </h1>
        
        <div className="max-w-3xl mx-auto">
          <p className="text-xl text-[#D4D1EC] mb-6">
            At RocketScanner.com, we're not just building software — we're solving real-world problems rooted in decades of auction experience.
          </p>
          
          <p className="text-xl text-[#D4D1EC] mb-6">
            Our team combines over 30 years in the auction industry with deep expertise in tech, AI, and software development. We've seen firsthand the time-consuming process of cataloging inventory, and we built RocketScanner to change that.
          </p>
          
          <p className="text-xl text-[#D4D1EC] mb-6">
            Proudly based in Nova Scotia, we know the value of hard work, honest business, and doing things right the first time. That's why our platform is built to be fast, reliable, and incredibly easy to use — whether you're managing an estate sale, running a liquidation, or streamlining consignments.
          </p>
          
          <p className="text-xl text-[#D4D1EC]">
            RocketScanner was created for auctioneers, resellers, and businesses ready to leave manual entry in the past and step into a smarter, more efficient way of working. This is Canadian-made tech, designed by people who live and breathe the auction world.
          </p>
        </div>
      </div>

      {/* Call to Action Section - Same as in PricingPage but with reduced spacing */}
      <div className="relative z-10 bg-[#103B3F] w-full py-16 md:py-24 mt-12 md:mt-16">
        <div className="px-4 sm:px-6 lg:px-8 mx-auto max-w-3xl text-center">
          <h3 className="text-white text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
            Join other auction companies and resellers using RocketScanner
          </h3>
          <p className="text-white text-base md:text-lg leading-relaxed mb-8">
            With RocketScanner, auction teams manage inventory with ease —<br />and stay focused on what matters most.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
            <a 
              href="/register" 
              className="flex items-center justify-center px-8 py-3 rounded-full bg-[#1DC9A0] font-bold text-[#0B0F19] shadow-md border-t border-[#66E0C2] hover:bg-[#66E0C2] transition-colors"
            >
              Get Started
            </a>
            <a 
              href="/pricing" 
              className="flex items-center justify-center text-white font-bold hover:text-[#AAA1FD] transition-colors"
            >
              View Pricing
              <svg className="ml-2" width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 1L24 11M24 11L13.5 21M24 11H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
